import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

export const ModalContext = createContext();

export const ModalContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  // Sweet alert fot invalid email & password //
  const showMessageNotification = (msg) => {
    return Swal.fire({
      title: msg.title,
      text: msg.text,
      icon: msg.icon,
      showCancelButton: msg.showCancelButton,
      confirmButtonColor: msg.confirmButtonColor,
      cancelButtonColor: msg.cancelButtonColor,
      confirmButtonText: msg.confirmButtonText,
    });
  };

  return (
    <ModalContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        showMessageNotification,
        editData,
        setEditData,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;

ModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
